<template>
    <modal-content @close="$emit('close')">
        <h3 v-if="unit">{{ unit.designation }}</h3>
        <br>
        <unit-form ref="form" @o3-submit="onSubmit($event)"/>
    </modal-content>
</template>

<script>
import ModalContent from 'domovio-core/src/components/Modal/ModalContent';
import UnitForm from '@/modules/ProjectModule/components/Dashboard/UnitForm';
import {loadUnit} from '@/modules/ProjectModule/modules/UnitModule/api/unit.api';

export default {
    name:       'UnitQuickUpdateDialog',
    components: {UnitForm, ModalContent},
    props:      {
        id: {
            type:     String,
            required: true,
        }
    },
    data() {
        return {
            processing: false,
            unit:       null,
        }
    },
    mounted() {
        loadUnit(this.id).then((unit) => {
            this.unit = unit;
            this.$refs.form.setUnit(this.unit);
        })
            .finally(() => this.processing = false)
    },
    methods:    {
        onSubmit(data) {
            const {id} = this.unit;
            this.$store.dispatch('projects/project/units/unit/updateUnit', {...data, id})
                .then(() => this.$emit('close'));
        }
    }
}
</script>
